import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  unReadNotificationCount: 0,
  states: [],
  selectedState: null,
};

const commonSlice = createSlice({
  name: "commonSlice",
  initialState,
  reducers: {
    setUnReadNotificationCount(state, action) {
      state.unReadNotificationCount = action.payload;
    },
    setStates(state, action) {
      state.states = action.payload;
    },
  },
});

export const { setUnReadNotificationCount, setStates } = commonSlice.actions;

export default commonSlice.reducer;
